import React from "react";
import Dropdown from "../../../component/dropdown/Dropdown";
import { useMasterAdmin } from "../MasterAdminContext";
import "./InstitutionScopeBar.css";

const InstitutionScopeBar = () => {
  const {
    institutionOptions,
    selectedInstitutionId,
    setSelectedInstitutionId,
    selectedInstitution,
    loading,
  } = useMasterAdmin();

  const input = { institution: selectedInstitutionId };

  const handleChange = (e) => {
    setSelectedInstitutionId(e.target.value);
  };

  const totals = selectedInstitution?.totals;

  return (
    <div className="ma-scope-bar">
      <div className="ma-scope-bar-inner">
        <div className="ma-scope-bar-label">
          <span className="ma-scope-bar-eyebrow">Institution scope</span>
          <span className="ma-scope-bar-hint">
            Select a workspace to manage its administrators or families.
          </span>
        </div>
        <div className="ma-scope-bar-control">
          <Dropdown
            placeholder={loading ? "Loading institutions..." : "Select institution..."}
            options={institutionOptions}
            name="institution"
            onChangeFunction={handleChange}
            input={input}
          />
        </div>
        {selectedInstitution && totals && (
          <div className="ma-scope-stats">
            <div className="ma-scope-stat">
              <span className="ma-scope-stat-value">{totals.admins ?? "—"}</span>
              <span className="ma-scope-stat-label">Admins</span>
            </div>
            <div className="ma-scope-stat">
              <span className="ma-scope-stat-value">{totals.parents ?? "—"}</span>
              <span className="ma-scope-stat-label">Parents</span>
            </div>
            <div className="ma-scope-stat">
              <span className="ma-scope-stat-value">{totals.children ?? "—"}</span>
              <span className="ma-scope-stat-label">Children</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstitutionScopeBar;
